module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/icon_tel-2a8ed53f2d4a088a3a66c805d73577c9.svg";